<template>
  <TheExchange v-if="$store.state.auth.isSignin">
    <div v-if="$store.state.saib.exchanges.length > 0">
      <ul class="list-type-3" v-for="(exchange, index) in $store.state.saib.exchanges" :key="index">
        <ExchangeItem
          :idx="exchange.idx"
          :status="exchange.status"
          :reason="exchange.reason"
          :wholesale="exchange.wholesale"
          :contents="exchange.contents"
          :details="exchange.details"
          :answer="exchange.answer"
          :uploadAt="$moment(exchange.uploadAt)"
        />
      </ul>
    </div>
    <div class="card-empty" v-else>
      <i class="no-content-logo"></i>
      <p>교환하거나 반납한 물품이 없습니다.</p>
    </div>
  </TheExchange>
</template>
<script>
import TheExchange from "@/components/Exchange/TheExchange";
import ExchangeItem from "@/components/Exchange/ExchangeItem";
import { mapActions } from "vuex";

export default {
  name: "ExchangeStatus",
  components: { TheExchange, ExchangeItem },
  methods: mapActions(["refreshExchanges"]),
  mounted() {
    this.refreshExchanges();
  }
};
</script>